import { useStationsFinder } from '../stations/hooks/useStations';
import { Station } from '@app/core/types/stations';

export function useStationsQueryParamParser() {
  const finder = useStationsFinder();

  return {
    parse: (input: string) =>
      input
        .split(',')
        .map(finder)
        .filter((value): value is Station => !!value),
    serialize: (stations: Station[]) => stations.map((s) => s.id).join(','),
  };
}
